<template>
  <!-- prepend-icon before $attrs so a caller can override the trash icon -->
  <CelusButton
    :prepend-icon="ICONS.delete"
    v-bind="$attrs"
    color="error"
    variant="flat"
  >
    <slot />
  </CelusButton>
</template>

<script setup lang="ts">
import CelusButton from "@/components/util/CelusButton.vue";
import { ICONS } from "@/libs/icons";

defineOptions({
  name: "CelusErrorButton",
  inheritAttrs: false,
});
</script>
